import { RouterState } from 'connected-react-router';
import { OptionsObject, SnackbarKey, SnackbarMessage } from 'notistack';

export interface User {
    accessFailedCount: number;
    concurrencyStamp: any;
    email: string;
    emailConfirmed: string;
    fullName: string;
    id: string;
    lockoutEnabled: boolean;
    lockoutEnd: boolean;
    normalizedEmail: boolean;
    normalizedUserName: boolean;
    password: string;
    phoneNumber: string;
    phoneNumberConfirmed: boolean;
    securityStamp: string;
    store: string;
    storeID: number;
    twoFactorEnabled: boolean;
    userName: string;
    timestamp?: string;
}

export type ProductCategory = {
    id: number;
    imageID: number;
    imageName: string;
    name: string;
    timestamp?: string;
};

export enum ImageType {
    COFFEE = 1,
    BEVERAGE = 2,
    COCTAIL = 3,
    FOOD = 4,
    BURGER = 5,
    WINE = 6,
    BEER = 7,
    SWEETS = 8,
    BREAKFAST = 9,
    ICE_CREAM = 10,
    FISH = 11,
    MEAT = 12,
    PIZZA = 13
}

export interface CategoryImage {
    id: number;
    name: string;
    type: ImageType;
}

export interface Table {
    id: number;
    code: string;
    description: string;
    allowedPeople: number;
}

export interface StoreConfiguration {
    defaultUILanguageID: number;
    defaultMenuLanguageID: number;
    licenceID: number;
    defaultAllowedPeoplePerTable: number;
    canUserPayWithCard: boolean;
    isCardReaderMobile: boolean;
    cardReaderAmount: number;
    providesFreeWifi: boolean;
    hasSmartFeaturesEnabled: boolean;
    hasOrderGeolocationActivated: boolean;
    hasOrder2FaAuthenticationEnabled: boolean;
    hasConfiguredLogo: boolean;
    shortUniqueID: string;
    paysMonthly: boolean;
    storeName: string;
    id: number;
    timestamp: string;
    selectedLanguages: {
        languageID: number;
        isSelectedUI: boolean;
        timestamp: string;
        id: number;
    }[];
}

export interface Language {
    name: string;
    code: string;
    id: number;
}

export interface Product {
    description: string;
    id: number;
    name: string;
    price: number;
    productCategoryID: number;
    storeID: number;
    productVarieties: {
        name: string;
        price: number;
        isDefault: boolean;
        id: number;
    }[];
}

export type Closure<T extends string | moment.Moment = moment.Moment> = {
    closureNotification: string;
    effectiveByDate: T;
    startDate: T;
    endDate: T;
    id: number;
    storeID: number;
    shortDescription: string;
};

export interface AppStore {
    user: User;
    users: User[];
    productCategories: ProductCategory[];
    notifications: INotification[];
    categoryImages: CategoryImage[];
    tables: Table[];
    storeConfiguration: StoreConfiguration;
    availableLanguages: Language[];
    products: Product[];
    loading: boolean;
    closures: Closure[];
}

export interface Store {
    router?: RouterState;
    app: AppStore;
}

export interface INotification {
    message: SnackbarMessage;
    options: OptionsObject;
    key: SnackbarKey;
}
